import { Component } from '@angular/core';
import { MerchantsSideMenu } from '../merchants-side-menu/merchants-side-menu';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-merchants-details',
  imports: [MerchantsSideMenu, RouterOutlet],
  templateUrl: './merchants-details.html',
  styleUrl: './merchants-details.scss',
})
export class MerchantsDetails {}
